/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { PageableObject } from './PageableObject';
import {
    PageableObjectFromJSON,
    PageableObjectFromJSONTyped,
    PageableObjectToJSON,
    PageableObjectToJSONTyped,
} from './PageableObject';
import type { SortObject } from './SortObject';
import {
    SortObjectFromJSON,
    SortObjectFromJSONTyped,
    SortObjectToJSON,
    SortObjectToJSONTyped,
} from './SortObject';
import type { JobEntryDTO } from './JobEntryDTO';
import {
    JobEntryDTOFromJSON,
    JobEntryDTOFromJSONTyped,
    JobEntryDTOToJSON,
    JobEntryDTOToJSONTyped,
} from './JobEntryDTO';

/**
 * 
 * @export
 * @interface PageJobEntryDTO
 */
export interface PageJobEntryDTO  {
    /**
     * 
     * @type {number}
     * @memberof PageJobEntryDTO
     */
    totalPages?: number;
    /**
     * 
     * @type {number}
     * @memberof PageJobEntryDTO
     */
    totalElements?: number;
    /**
     * 
     * @type {PageableObject}
     * @memberof PageJobEntryDTO
     */
    pageable?: PageableObject;
    /**
     * 
     * @type {SortObject}
     * @memberof PageJobEntryDTO
     */
    sort?: SortObject;
    /**
     * 
     * @type {boolean}
     * @memberof PageJobEntryDTO
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageJobEntryDTO
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageJobEntryDTO
     */
    numberOfElements?: number;
    /**
     * 
     * @type {number}
     * @memberof PageJobEntryDTO
     */
    size?: number;
    /**
     * 
     * @type {Array<JobEntryDTO>}
     * @memberof PageJobEntryDTO
     */
    content?: Array<JobEntryDTO>;
    /**
     * 
     * @type {number}
     * @memberof PageJobEntryDTO
     */
    number?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageJobEntryDTO
     */
    empty?: boolean;
}

/**
 * Check if a given object implements the PageJobEntryDTO interface.
 */
export function instanceOfPageJobEntryDTO(value: object): value is PageJobEntryDTO {
    return true;
}

export function PageJobEntryDTOFromJSON(json: any): PageJobEntryDTO {
    return PageJobEntryDTOFromJSONTyped(json, false);
}

export function PageJobEntryDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageJobEntryDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'totalPages': json['totalPages'] == null ? undefined : json['totalPages'],
                  'totalElements': json['totalElements'] == null ? undefined : json['totalElements'],
                  'pageable': json['pageable'] == null ? undefined : PageableObjectFromJSON(json['pageable']),
                  'sort': json['sort'] == null ? undefined : SortObjectFromJSON(json['sort']),
                  'first': json['first'] == null ? undefined : json['first'],
                  'last': json['last'] == null ? undefined : json['last'],
                  'numberOfElements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
                  'size': json['size'] == null ? undefined : json['size'],
              'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(JobEntryDTOFromJSON)),
                  'number': json['number'] == null ? undefined : json['number'],
                  'empty': json['empty'] == null ? undefined : json['empty'],
    };
}

export function PageJobEntryDTOToJSON(json: any): PageJobEntryDTO {
    return PageJobEntryDTOToJSONTyped(json, false);
}

export function PageJobEntryDTOToJSONTyped(value?: PageJobEntryDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'totalPages': value['totalPages'],
        'totalElements': value['totalElements'],
        'pageable': PageableObjectToJSON(value['pageable']),
        'sort': SortObjectToJSON(value['sort']),
        'first': value['first'],
        'last': value['last'],
        'numberOfElements': value['numberOfElements'],
        'size': value['size'],
        'content': value['content'] == null? value['content']: (value['content'] as Array<any>).map(JobEntryDTOToJSON),
        'number': value['number'],
        'empty': value['empty'],
    };
}


